// About Us — Campaign Collection Insert Banner (2026-08-02)
// Targets: /collections/* pages
//
// Reads active campaign inserts from /api/campaign-inserts/active-collection.
// Shows a dismissible banner at the top of collection pages.
// Dismissal is sessionStorage-scoped (clears on tab close).
//
// This script is injected into the live Shopify theme via the admin endpoint:
//   POST /api/admin/wire-campaign-collection-insert-20260802
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (!/\/collections\//i.test(location.pathname)) return;
  if (window.__auCampaignInsertLoaded) return;
  window.__auCampaignInsertLoaded = true;

  var STORAGE_PREFIX = 'au_insert_dismissed_';
  var BRAND_NAVY  = '#131936';
  var BRAND_MILK  = '#F4F1EA';
  var FONT_BODY   = "'Raleway', 'Helvetica Neue', sans-serif";

  function isDismissed(insertId) {
    try { return sessionStorage.getItem(STORAGE_PREFIX + insertId) === '1'; } catch (e) { return false; }
  }

  function markDismissed(insertId) {
    try { sessionStorage.setItem(STORAGE_PREFIX + insertId, '1'); } catch (e) {}
  }

  function injectBanner(insert) {
    if (!insert || !insert.id) return;
    if (isDismissed(insert.id)) return;

    var bg  = insert.background_colour || BRAND_NAVY;
    var fg  = insert.text_colour || BRAND_MILK;

    var banner = document.createElement('div');
    banner.id = 'au-campaign-insert-banner';
    banner.setAttribute('role', 'banner');
    banner.style.cssText = [
      'position:sticky;top:0;z-index:9000',
      'background:' + bg,
      'color:' + fg,
      'font-family:' + FONT_BODY,
      'display:flex;align-items:center;justify-content:center',
      'padding:12px 48px 12px 20px',
      'min-height:48px',
      'gap:16px',
    ].join(';');

    // Headline + subline
    var textWrap = document.createElement('div');
    textWrap.style.cssText = 'display:flex;align-items:baseline;flex-wrap:wrap;gap:8px;';

    if (insert.headline) {
      var hl = document.createElement('span');
      hl.textContent = insert.headline;
      hl.style.cssText = 'font-size:12px;font-weight:700;letter-spacing:0.1em;text-transform:uppercase;';
      textWrap.appendChild(hl);
    }
    if (insert.subline) {
      var sl = document.createElement('span');
      sl.textContent = insert.subline;
      sl.style.cssText = 'font-size:12px;opacity:0.7;';
      textWrap.appendChild(sl);
    }
    banner.appendChild(textWrap);

    // CTA link
    if (insert.cta_text && insert.cta_url) {
      var cta = document.createElement('a');
      cta.href = insert.cta_url;
      cta.textContent = insert.cta_text;
      cta.style.cssText = [
        'font-size:11px;font-weight:600;letter-spacing:0.08em;text-transform:uppercase',
        'border:1px solid ' + fg,
        'color:' + fg,
        'padding:5px 12px',
        'text-decoration:none',
        'white-space:nowrap',
        'opacity:0.9',
      ].join(';');
      cta.addEventListener('mouseenter', function () { cta.style.opacity = '1'; });
      cta.addEventListener('mouseleave', function () { cta.style.opacity = '0.9'; });
      banner.appendChild(cta);
    }

    // Dismiss (×) button
    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.setAttribute('aria-label', 'Dismiss');
    closeBtn.textContent = '×';
    closeBtn.style.cssText = [
      'position:absolute;right:14px;top:50%;transform:translateY(-50%)',
      'background:none;border:none;color:' + fg,
      'font-size:20px;cursor:pointer;opacity:0.6',
      'line-height:1;padding:4px',
    ].join(';');
    closeBtn.addEventListener('mouseenter', function () { closeBtn.style.opacity = '1'; });
    closeBtn.addEventListener('mouseleave', function () { closeBtn.style.opacity = '0.6'; });
    closeBtn.addEventListener('click', function () {
      markDismissed(insert.id);
      banner.style.transition = 'opacity 0.2s';
      banner.style.opacity = '0';
      setTimeout(function () {
        if (banner.parentNode) banner.parentNode.removeChild(banner);
      }, 200);
    });
    banner.appendChild(closeBtn);

    // Insert before the first child of body, or before the header if present
    var header = document.querySelector('header, #shopify-section-header, .shopify-section-header');
    if (header && header.parentNode) {
      header.parentNode.insertBefore(banner, header);
    } else {
      document.body.insertBefore(banner, document.body.firstChild);
    }
  }

  // Absolute ops-app origin: the storefront (aboutusthelabel.com) does NOT proxy
  // /api/* to the Railway app, so a relative fetch 404s. The endpoint sends
  // Access-Control-Allow-Origin: * so this cross-origin GET is allowed.
  var OPS_API = 'https://about-us-opps-app-production.up.railway.app';

  function init() {
    fetch(OPS_API + '/api/campaign-inserts/active-collection', { cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) { if (data && data.insert) injectBanner(data.insert); })
      .catch(function () { /* silent — never break the storefront */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
